export default {
  formatIsoDate (date) {
    var dateTime = new Date(date)
    var dateString = dateTime.getDate() + '/'
    dateString += (dateTime.getMonth() + 1) + '/'
    dateString += dateTime.getFullYear()

    return dateString
  },
  formatAPIDate (date) {
    var dateString = date.getFullYear() + '-'
    dateString += ('0' + (date.getMonth() + 1)).slice(-2) + '-'
    dateString += ('0' + date.getDate()).slice(-2)

    return dateString
  }
}



// WEBPACK FOOTER //
// ./src/services/date_formatter.js